// Пометка для менеджера в карточке рейса: перевозчик-ИП в TMS уходит как собственный транспорт ALT.
// Правило Анны 01.11.2026: Эфес не принимает ИП-перевозчиков, поэтому машина ИП в TMS всегда
// «1 - Собственность» (так делает tms-service), а в ERP и «Пчёлке» перевозчик остаётся наёмным.
// Признак ИП зеркалит tms-service TmsPayloadBuilder.is_individual_entrepreneur.

// «1 - Собственность» — совпадает с src/constants/carOwnership.js (OWNERSHIP_OWNED).
export const OWNED_OWNERSHIP_ID = '552ca124-fa3f-483c-b8a6-42984ee7e5ab'

export function isIndividualEntrepreneur(company) {
  if (!company) return false
  const inn = String(company.inn ?? '').replace(/\s+/g, '')
  const name = String(company.name ?? '')
    .trim()
    .replace(/^[«"']+/, '')
    .trim()
    .toUpperCase()
  return (/^\d{12}$/.test(inn)) || name.startsWith('ИП ') || name.startsWith('ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ')
}

// Машина записана в ERP как собственная ALT — тогда расхождения нет и пометка не нужна.
export function isOwnedInErp(car) {
  if (!car) return false
  if (car.ownership_type_id && String(car.ownership_type_id) === OWNED_OWNERSHIP_ID) return true
  const name = String(car.ownership_type_name ?? car.ownership_type?.name ?? '').trim()
  return name.startsWith('1 -') || name.startsWith('1 –')
}

export function tmsOwnershipNote(executor) {
  const company = executor?.company
  if (!isIndividualEntrepreneur(company)) return null
  if (isOwnedInErp(executor?.car)) return null
  const carrier = String(company.name ?? '').trim() || 'ИП'
  return {
    title: 'Реальный тип владения: наёмный',
    text: `Перевозчик — ${carrier}. В TMS машина уходит как «Собственность» ALT: Эфес не принимает ИП-перевозчиков. В ERP и «Пчёлке» перевозчик остаётся наёмным.`,
  }
}
